import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Car, ArrowLeft, ArrowRight } from "lucide-react";
import { PackageData } from "@/pages/CreatePackage";
import { toast } from "sonner";
import { PackageTransportList } from "./TransportStep/PackageTransportList";
import { AddTransportForm } from "./TransportStep/AddTransportForm";
import { ProgressSteps } from "./ProgressSteps";
interface TransportStepProps {
  data: PackageData;
  onUpdate: (data: Partial<PackageData>) => void;
  onNext: () => void;
  onPrev: () => void;
  completedSteps?: number[];
  onStepClick?: (step: number) => void;
  isStepRequired?: (step: number) => boolean;
}
export const TransportStep = ({
  data,
  onUpdate,
  onNext,
  onPrev,
  completedSteps = [],
  onStepClick = () => {},
  isStepRequired = () => true
}: TransportStepProps) => {
  const [transport, setTransport] = useState(data.transport);
  const handleAddTransport = (newTransport: PackageData['transport'][0]) => {
    const updatedTransport = [...transport, newTransport];
    setTransport(updatedTransport);
    onUpdate({
      transport: updatedTransport
    });
    toast.success("تمت إضافة المواصلات بنجاح.");
  };
  const handleRemoveTransport = (index: number) => {
    const updatedTransport = transport.filter((_, i) => i !== index);
    setTransport(updatedTransport);
    onUpdate({
      transport: updatedTransport
    });
    toast.info("تمت إزالة المواصلات.");
  };
  return <Card className="w-full">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Car className="w-5 h-5" />
          المواصلات
        </CardTitle>
        
      </CardHeader>
      <CardContent className="space-y-6">
        
        <PackageTransportList packageTransport={transport} onRemoveTransport={handleRemoveTransport} />

        <AddTransportForm onAddTransport={handleAddTransport} />

        <div className="flex justify-between pt-6 border-t mt-6">
          <Button variant="outline" onClick={onPrev}>
            <ArrowRight className="w-4 h-4 ml-2" />
            السابق
          </Button>
          <Button onClick={onNext} className="bg-blue-600 hover:bg-blue-700">
            التالي
            <ArrowLeft className="w-4 h-4 mr-2" />
          </Button>
        </div>
      </CardContent>
      
      {/* Progress Steps */}
      <ProgressSteps 
        currentStep={4} 
        completedSteps={completedSteps} 
        onStepClick={onStepClick} 
        isStepRequired={isStepRequired} 
      />
    </Card>;
};